import React, { useCallback } from "react";
import { workflowService } from "/app/src/services";
import { useTranslation } from "react-i18next";
import { Button } from "@heroui/react";

/**
 * Renders a test workflow component that triggers a workflow test.
 *
 * @param {Object} props - The component properties.
 * @param {number | undefined} props.workflowId - The unique identifier for the workflow.
 * @returns {JSX.Element} The rendered TestWorkflow component.
 */
export default function TestWorkflow({
  workflowId,
}: {
  workflowId: number | undefined;
}) {
  const { t } = useTranslation();

  const testWorkflowHandler = useCallback(() => {
    if (!workflowId) return;
    workflowService.testSingle(workflowId);
  }, [workflowId]);

  return (
    <div className="testWorkflow">
      <Button
        fullWidth
        radius="none"
        color="default"
        variant="bordered"
        size="sm"
        onPress={testWorkflowHandler}
        className="hover:border-primary-default hover:text-primary-default bg-white"
      >
        {t("translation:manually_trigger_")}
        {t("translation:workflow")}
      </Button>
    </div>
  );
}
